<template>
  <div class="page-wrapper">
    <div class="page-content">
      <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb mb-0 p-0">
            <li class="breadcrumb-item">
              <router-link to="/home"><i class="bx bx-home-alt"></i></router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Update Service
            </li>
          </ol>
        </nav>
        <div class="ms-auto"></div>
      </div>
      <hr />
      <form>
        <div class="card">
          <div class="card-body p-4">
            <h5 class="card-title">Update Service</h5>
            <hr />
            <div class="form-body mt-4">

              <div class="row">
                <div class="col-lg-8">

                  <div class="border border-3 p-4 rounded mb-4">
                    <div class="mb-3">
                      <label for="inputProductTitle" class="form-label">Service Title:</label>
                      <input type="text" class="form-control" id="inputProductTitle" v-model="singleProduct.title"/>
                    </div>
                  </div>

                  <div class="border border-3 p-4 rounded mb-3">
                    <div class="row mb-3">
                      <div class="col-md-12">
                        <label class="form-label" for="description">Description:</label>
                        <ckeditor :editor="editor" v-model="singleProduct.description" :config="editorConfig"></ckeditor>
                      </div>
                    </div>
                  </div>

                  <div class="border border-3 p-4 rounded">
                    <div class="mb-3">
                      <label for="exampleInputEmail1">Featured Image:
                        <strong>[Preferred Image Size: 400X400, Max Upload Limit:
                          1MB]</strong></label>
                      <input class="form-control mb-2" type="file" name="featuredImage" id="featuredImage"
                        ref="featuredImage" aria-describedby="imageHelp" accept="image/*"
                        @change="uploadFeaturedImage($event)"/>
                      <img v-if="previewFeaturedImage" :src="previewFeaturedImage" height="90" />
                      <img v-else :src="singleProduct.featuredImage" height="80" />
                    </div>
                    <div class="row mb-3">
                      <div class="col-6">
                        <label for="inputProductTitle" class="form-label">Featured Image Title:</label>
                        <input type="text" class="form-control" id="inputProductTitle" v-model="singleProduct.featuredImageTitle"
                        placeholder="Featured Image Title" />
                      </div>
                      <div class="col-6">
                        <label for="inputProductTitle" class="form-label">Featured Image Alt:</label>
                        <input type="text" class="form-control" id="inputProductTitle" v-model="singleProduct.featuredImageAlt"
                        placeholder="Enter Featured Image Alt" />
                      </div>
                    </div>
                  </div>
                  
                  <div class="border border-3 p-4 rounded mt-3">
                    <div class="mb-3">
                      <label for="exampleInputEmail1">Icon:
                        <strong>[Preferred Image Size: 400X400, Max Upload Limit:
                          1MB]</strong></label>
                      <input class="form-control mb-2" type="file" name="icon" id="icon"
                        ref="iconInput" aria-describedby="imageHelp" accept="image/*"
                        @change="uploadIcon($event)" />
                      <img v-if="previewIcon" :src="previewIcon" height="90" />
                      <img v-else :src="singleProduct.icon" height="80" />
                    </div>
                    <div class="row mb-3">
                      <div class="col-6">
                        <label for="inputProductTitle" class="form-label">Icon Title:</label>
                        <input type="text" class="form-control" id="inputProductTitle" v-model="singleProduct.iconTitle"
                        placeholder="Enter Icon Title" />
                      </div>
                      <div class="col-6">
                        <label for="inputProductTitle" class="form-label">Featured Image Title:</label>
                        <input type="text" class="form-control" id="inputProductTitle" v-model="singleProduct.iconAlt"
                        placeholder="Enter Icon Alt" />
                      </div>
                    </div>
                  </div>

                  <div class="border border-3 p-4 rounded">
                    <div class="mb-3">
                      <label for="categoryList" class="form-label">Category:</label>
                      <select v-model="category" class="form-select form-control mb-3" id="categoryList">
                        <option class="p-1" v-for="(row, index) in categoryList" :key="index"
                          :value="{ _id: row._id, title: row.title }">
                          {{ row.title }}
                        </option>
                      </select>
                    </div>
                  </div>  

                  <div class="border border-3 p-4 rounded mb-4">
                    <div class="col-sm-12 col-md-6">
                        <label for="inputProductTitle" class="form-label">Meta Title:</label>
                      <input type="text" class="form-control" id="inputProductTitle" v-model="singleProduct.metaTitle"
                        placeholder="Meta Title" />
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <label for="inputProductTitle" class="form-label">Meta Keyword:</label>
                      <input type="text" class="form-control" id="inputProductTitle" v-model="singleProduct.metaKeyword"
                        placeholder="Meta Keyword" />
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <label for="inputProductTitle" class="form-label">Meta Description</label>
                      <input type="text" class="form-control" id="inputProductTitle" v-model="singleProduct.metaDescription"
                        placeholder="Meta Description" />
                      </div>
                    <div class="mb-3 col-sm-12 col-md-6">
                      <label for="inputProductTitle" class="form-label">Service Canonical Url:</label>
                      <input type="text" class="form-control" id="inputProductTitle" v-model="singleProduct.canonicalUrl"/>
                    </div>
                  </div>

                  <div class="border border-3 p-4 rounded mt-3">
                    <div class="mb-3">
                      <label for="exampleInputEmail1">Is Featured: </label>
                      <div class="form-check form-switch mt-1">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked"
                          v-model="isFeatured" />
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mt-3">
                    <div class="d-grid">
                      <button type="button" @click="updateService" class="btn btn-primary">
                        Update Service
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!--end row-->
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script src='../js/update-service.js'></script>